// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// import { getStorage } from "firebase/storage"; // If you need storage later

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Dynamic authDomain resolver:
// Using the same domain as the page avoids Safari ITP / third-party storage blocking for the
// Firebase auth helper iframe. This ONLY works on domains served by Firebase Hosting (they proxy
// /__/auth/*). Unknown hosts (translation proxies, other hosting) fall back to the default.
// If you connect a custom domain to Firebase Hosting, add it to this list.
const FIREBASE_HOSTING_DOMAINS = [
  "kodutara.web.app",
  "kodutara.firebaseapp.com",
  "kodutara.com",
  "www.kodutara.com"
];

const getAuthDomain = () => {
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname;
    if (FIREBASE_HOSTING_DOMAINS.includes(host)) {
      return host;
    }
  }
  return "kodutara.firebaseapp.com";
};

const firebaseConfig = {
  apiKey: "AIzaSyB1istt2kKe6hZctORhkbfnO-XTH7PXSSs",
  authDomain: getAuthDomain(),
  projectId: "kodutara",
  storageBucket: "kodutara.firebasestorage.app",
  messagingSenderId: "480216250488",
  appId: "1:480216250488:web:0549f3e7ca976b9e90558d",
  measurementId: "G-RBCYZ55EC1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
try {
  auth.languageCode = "tr";
} catch (_) {
  /* ignore */
}
const db = getFirestore(app);
let analytics = null;
if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Firebase Analytics could not be initialized:", e);
  }
}

export { app, auth, db, analytics /*, storage */ };